import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {AangifteRapport} from '@snelstart-ventures/fiscaal/domain-logic';
import {FormControl, FormGroup} from '@angular/forms';
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {CommonModule} from '@angular/common';
import {BehaviorSubject} from "rxjs";
import {SharedUiButtonModule} from "@snelstart/ui-button";
import {SharedUiDialogModule} from "@snelstart/ui-dialog";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-giften',
  templateUrl: './spec-giften.component.html',
  styleUrls: ['./spec-giften.component.scss'],
  imports: [SharedUiDetailsModule, SharedUiFormControlsModule, CommonModule, SharedUiButtonModule, SharedUiDialogModule],
})
export class SpecGiftenComponent implements OnChanges {

  @Input() public id!: string;
  @Input({required: true}) public rapport!: AangifteRapport;
  public dataVisible$ = new BehaviorSubject<boolean>(false);
  public dialogVisible = false;

  public formGroup = new FormGroup({
    aftrekbareGiften: new FormControl<number | null>(0),
    gewoneGiften: new FormControl<number | null>(0),
    gewoneGiftenCultureel: new FormControl<number | null>(0),
    totaalGewoneGiften: new FormControl<number | null>(0),
    aftrekbareGewoneGiften: new FormControl<number | null>(0),
    periodiekeGiften: new FormControl<number | null>(0),
    periodiekeGiftenCultureel: new FormControl<number | null>(0),
    totaalPeriodiekeGiften: new FormControl<number | null>(0),
    verhogingGewoneCultureleGiften: new FormControl<number | null>(0),
    verhogingPeriodiekeCultureleGiften: new FormControl<number | null>(0),
    aftrekbarePeriodiekeGiften: new FormControl<number | null>(0),
    giftenVoorDrempel: new FormControl<number | null>(0),
    drempelGiften: new FormControl<number | null>(0),
    totaalGiftenaftrek: new FormControl<number | null>(0),
    aandeelGiftenaftrek: new FormControl<number | null>(0),
  });

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['rapport'] && this.rapport) {
      this.formGroup.reset({}, {emitEvent: false});
      this.formGroup.patchValue(this.rapport.specificatieGiften?.opbouw || {}, {emitEvent: false});
      this.formGroup.patchValue({totaalGewoneGiften: (this.formGroup.controls.gewoneGiften.value ?? 0) + (this.formGroup.controls.gewoneGiftenCultureel.value ?? 0)}, {emitEvent: false});
      this.formGroup.patchValue({giftenVoorDrempel: (this.formGroup.controls.totaalGewoneGiften.value ?? 0) + (this.formGroup.controls.verhogingGewoneCultureleGiften.value ?? 0)}, {emitEvent: false});
      this.formGroup.patchValue({aftrekbareGewoneGiften: (this.formGroup.controls.totaalGewoneGiften.value ?? 0) + (this.formGroup.controls.drempelGiften.value ?? 0)}, {emitEvent: false});
      this.formGroup.disable();
      this.dataVisible$.next(true);
    }
  }

  showDialog() {
    this.dialogVisible = true;
  }
}
